module.exports = __webpack_public_path__ + "static/media/Growbag1.92fa1d5e.webp";